<template>
	<div>
		<h1>Debi/Kredi - Personenkonten</h1>
		<button @click="$router.push({ path: '/home/arap'})"><i class="fas fa-chevron-left rmargin"></i> Zurück zur OP-Liste</button>

		<br>
		
		<table>
			<thead>
				<th>Pers.kto.nr.</th>
				<th>Firma / Name</th>
				<th>Strasse</th>
				<th>Ort</th>
				<th>Land</th>
				<th>Typ</th>
				<th>Whr</th>
				
				<th></th>
			</thead>
			<tbody>

				<tr v-for="(rec,idx) in recs" :key="rec.id">
					<td>{{ rec.number }}</td>
					<td>{{ rec.name }}</td>
					<td>{{ rec.street }}</td>
					<td>{{ rec.location }}</td>
					<td>{{ rec.country }}</td>
					<td><span class="badge" :class="rec.type">{{ rec.type === 'ar' ? 'DEBI' : 'KREDI' }}</span></td>
					<td>{{ rec.ccy }}</td>
					
					<td><i class="fas fa-pencil-alt" title="Bearbeiten" @click="editPA(rec.id)"></i></td>
				</tr>
			</tbody>
		</table>
		
		<modal name="modalEdit" width="350" height="auto" :clickToClose="false" draggable=".delConf-title">
			<div class="delConf-title">Personenkonto bearbeiten</div>
			<div class="delConf-content">
				<label>Personenkontonummer</label>
				<input type="text" v-model="pa_dlg.number">
				
				<label>Name</label>
				<input type="text" v-model="pa_dlg.name">
				
				<label>Strasse</label>
				<input type="text" v-model="pa_dlg.street">
				
				<label>PLZ/Ort</label>
				<input type="text" v-model="pa_dlg.location">
				
				<label>Land (Kürzel, z.B. CH)</label>
				<input type="text" v-model="pa_dlg.country">
				
				<label>Typ</label>
				<select v-model="pa_dlg.type">
					<option value="ar">Debitor</option>
					<option value="ap">Kreditor</option>
				</select>
				
				<label>Währung</label>
				<select v-model="pa_dlg.currency_id">
					<option v-for="ccy in ccy_recs" :key="ccy.id" :value="ccy.id">{{ ccy.iso_code }} - {{ ccy.description }}</option>
				</select>
				
				<button @click="deleteBanks()" class="btn-reset"><i class="fas fa-times-circle"></i> Kontoverbindungen zurücksetzen</button>
				<button @click="deleteTokenpos()" class="btn-reset"><i class="fas fa-times-circle"></i> Wort-Positionen zurücksetzen</button>
			</div>
			<div class="delConf-button-wrapper">
				<button @click="savePA()" class="delConf-btn-del">Speichern</button>
				<button @click="$modal.hide('modalEdit')">Abbrechen</button>
			</div>
		</modal>
		
		<modal name="modalDel" width="350" height="auto" :clickToClose="false" draggable=".delConf-title">
			<div class="delConf-title">Löschung bestätigen</div>
			<div class="delConf-content">
				Import-Daten '{{ selected_name }}' wirklich löschen?
			</div>
			<div class="delConf-button-wrapper">
				<button @click="deleteRec" class="delConf-btn-del">Löschen</button>
				<button @click="$modal.hide('modalDel')">Abbrechen</button>
			</div>
		</modal>
		
		<vue-snotify></vue-snotify>
	</div>
</template>

<script>
  import ApiComm from '../../apicomm.js'
  import axios from 'axios'
  
  export default {
    components: {},
    mixins: [ApiComm],
	data() {
		return {
			selected_id: '',
			selected_name: '',
			reftype: '',
			reftypes: [],
			recs: [],
			hndlEvent: 0,
			ccy_recs: [],
			pa_dlg: {
				id: 0,
				number: '',
				name: '',
				street: '',
				location: '',
				country: '',
				type: '',
				currency_id: 0
			}
		}
	},
    computed: {
		client_id () {
			return this.$store.state.customer.id
		},
	},
    methods: {
		savePA() {
			var p = this.$_.clone(this.pa_dlg);
			p['client_id'] = this.client_id;
			this.apiCall([{method: 'arap/acct/save', param: p, id: 12},{method: 'arap/acct/list', param: {client_id: this.client_id}, if: [{id: 12, path: 'result/success', eq: true}], id: 10}], this.evalApiResponse);
		},
		
		editPA(id) {
			this.apiCall({method: 'arap/acct/load', param: {id: id, client_id: this.client_id}, id: 11}, this.evalApiResponse);
		},
		
		deleteBanks() {
			this.apiCall({method: 'arap/acct/delete', param: {id: this.pa_dlg.id, mode: 'banks'}, id: 21}, this.evalApiResponse);
		},
		
		deleteTokenpos() {
			this.apiCall({method: 'arap/acct/delete', param: {id: this.pa_dlg.id, mode: 'tokenpos'}, id: 21}, this.evalApiResponse);
		},
		
		data_update_handler(data) {
			console.log('data_update_handler -> ' + JSON.stringify(data));
			var idx = this.recs.findIndex(x => x.id === data.id);
			if (idx !== -1) {
				if (data.hasOwnProperty('error')) {
					this.recs[idx].status = 'error';
					this.recs[idx]['error'] = data.error.msg;
				} else {
					this.recs[idx].status = 'submitted';
					this.recs[idx].reftype = data.reftype;
					this.recs[idx].refnum = data.refnum;
					if (this.recs[idx].hasOwnProperty('error')) delete this.recs[idx].error;
					
					this.recs.push({});
					this.recs.pop();
				}
			}
		},
		
		deleteShowDlg: function (rid) {
			this.selected_id = rid
			this.selected_name = ''
			var i
			for(i=0; i<this.recs.length; i++) {
				if (this.recs[i].id === rid) {
					this.selected_name = this.recs[i].name
					break
				}
			}
			this.$modal.show('modalDel')
		},
		deleteRec: function () {
			var vm = this
			vm.apiCall([{method: 'arap/document/delete', param: {id: vm.selected_id}, id: 12},{method: 'arap/acct/list', param: {client_id: vm.client_id}, if: [{id: 12, path: 'result/success', eq: true}], id: 10}], this.evalApiResponse)
			this.$modal.hide('modalDel')
		},
		editDoc: function (rid) {
//			var vm = this
//			vm.apiCall([{method: 'import/load', param: {id: rid}, id: 20}], vm.evalApiResponse)
			this.$router.push({ path: '/home/arap/document/edit/'+rid})
		},
		
		populateDT: function () {
			var vm = this, r = [];
			
			r.push({method: 'client/param/currency/list', param: {client_id: vm.client_id}, id: 70});
			
			r.push({method: 'arap/acct/list', param: {client_id: vm.client_id}, id: 10});
			vm.apiCall(r, vm.evalApiResponse);
		},
		
		evalApiResponse: function (resp) {
			var vm = this, o, i, n;
			this.$_.forEach(resp, function (value) {
			  if (value.hasOwnProperty('id')) {
				switch (value.id) {
				  case 10: // 10 = Result from 'arap/acct/list'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
			//						console.log(value)
						o = value.result;
						n = o.length;
						for (i=0; i<n; i++) o[i]['selected'] = false;
						vm.recs = o;
					}
					break
				  case 11: // 11 = Result from 'arap/acct/load'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
						o = value.result;
						vm.pa_dlg.id = o.id;
						vm.pa_dlg.number = o.number;
						vm.pa_dlg.name = o.name;
						vm.pa_dlg.street = o.street;
						vm.pa_dlg.location = o.location;
						vm.pa_dlg.country = o.country;
						vm.pa_dlg.type = o.type;
						vm.pa_dlg.currency_id = o.currency_id;

						vm.$modal.show('modalEdit');
					}
					break
				  case 12: // 12 = Result from 'arap/acct/save'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
						vm.$modal.hide('modalEdit');
						vm.$snotify.success('Personenkonto gespeichert', 'OK')
					}
					break
				  case 21: // 21 = Result from 'arap/acct/delete'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
						vm.$snotify.success('Daten wurden gelöscht', 'OK')
					}
					break
/*
				  case 12: // 12 = Result from 'arap/document/delete'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
						vm.$snotify.success('OP gelöscht', 'OK')
					}
					break
				  case 19: // 19 = Result from 'arap/document/set_status'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
						if (value.result.hasOwnProperty('remote_id') && value.result.hasOwnProperty('value')) vm.recs[value.result.remote_id].payment_pending = value.result.value;
					}
					break
				  case 20: // 20 = Result from 'import/load'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
			//						console.log(value)
						vm.$store.commit('set_import_param', value.result)
						vm.$router.push({ path: '/home/import/upload'})
					}
					break
				  case 30: // 30 = Result from 'import/submit/enter'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
						if (value.result.hasOwnProperty('incomplete')) vm.$snotify.error('Die Daten wurden übermittelt. Siehe Buchungsprotokoll für Details.', 'ERROR', {timeout: 8000})
						else vm.$snotify.success('Die Daten wurden verbucht', 'OK')
					}
					break
*/
				  case 70: // 70 = Result from 'client/param/currency/list'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
						vm.ccy_recs = value.result
					}
					break
				}
			  }
			})
		}
    },
    filters: {
		recdate: function (val) {
			var a = val.substr(0,10).split('-')
			return a[2] + '.' + a[1] + '.' + a[0]
		},
		recstatus: function (val) {
			switch(val) {
				case 'PENDING': return 'AUSSTEHEND'
				case 'DOWNLOADED': return 'HERUNTERGELADEN'
				case 'SUBMITTED': return 'ÜBERMITTELT'
				default: return ''
			}
		}
    },
    watch: {
		client_id (newVal, oldVal) {
			this.populateDT();
		}
    },
    mounted: function () {
		this.populateDT();
    }
  }
</script>

<style scoped="">
button {
	border: 1px solid #000;
	background: #888;
	color: #fff;
	margin-bottom: 20px;
	margin-right: 5px;
	padding: 5px 10px;
	cursor: pointer;
	font-weight: 700;
}

button:hover {
	background: #666;
}

table {
	border-collapse: collapse;
	border: 1px solid #888;
	margin-bottom: 20px;
}

th {
	background: #317dff;
	color: #fff;
	padding: 10px 10px;
	min-width: 30px;
	text-align: left;
	border-bottom: 1px solid #888;
}

td {
	color: #333;
	padding: 10px 10px;
	text-align: left;
}

tr:nth-child(even) {background: #eee}
tr:nth-child(odd) {background: #fff}

tr.approved {background: #a9ffa9}

td > i {
	cursor: pointer;
}

input[type=text], select {
	border: 1px solid #888;
	padding:3px;
	background: #fff;
}

.badge {
	border-radius: 5px;
	padding: 3px 5px;
	color: #fff;
}

.badge.ar {
	background: #1E90FF;
}

.badge.ap {
	background: #AF04AF;
}

.badge.pending {
	background: #888;
}

.badge.ready {
	background: #FFA500;
}

.badge.submitted {
	background: #008000;
}

.badge.error {
	background: #f00;
}


/* CONFIRM DELETION*/
.delConf-title {
	cursor: move;
	font-weight: 700;
	line-height: 40px;
	border-bottom: 1px solid #aaa;
	padding: 0 10px;
}

.delConf-content {
	padding: 20px 10px;
}

.delConf-button-wrapper {
	border-top: 1px solid #aaa;
	padding: 10px 10px 0 10px;
}

.delConf-button-wrapper button {
	margin-left: 5px;
}

.delConf-btn-del {
	background: #c00;
}

.delConf-btn-del:hover {
	background: #a00;
}

.disabled {
	cursor: auto;
	color: #aaa;
}

.anl {
	text-decoration: none;
	color: #000;
}


.filterwrp {
	display: inline-flex;
	flex-direction: column;
	background: #fff;
	border: 1px solid #888;
	margin-bottom: 10px;
	margin-right: 10px;
}

.filterwrp > div {
	padding: 5px;
}

.filterwrp > div:first-child {
	color: #eee;
	background: #888;
	font-weight: bold;
}
.filterwrp > div:first-child > i {
	margin-right: 5px;
}

.filterwrp .dateflds > input[type=text] {
	width: 85px;
}

.date_err {
	background: #fcc!important;
}

.dnldbtn:disabled {
	opacity: 0.33;
	cursor: inherit;
}

.stxt {
	width: 100px;
}

.fas.rmargin, .far.rmargin {
	margin-right:5px;
}

.reftype label {
	margin-right: 20px;
}

label {
	display: block;
	font-size: 85%;
	margin-bottom: 3px;
}

input[type=text],select {
	width: 100%!important;
	margin-bottom: 10px;
}

.btn-reset {
	margin: 0;
	margin-top: 10px;
}
</style>
